<template>
  <el-select 
    v-model="val" 
    class="ANumberSelector inline" 
    size="mini"
    @change="change">
    <el-option
      v-if="showZero"
      :label="zeroString" 
      :value="0"
    />
    <el-option
      v-for="n in items"
      :key="n"
      :label="prefixString + n + suffixString" 
      :value="n"
    />
  </el-select>
</template>
<script>
import { selector } from "@/common/mixins/selector";

export default {
  name: "ANumberSelector",
  mixins: [selector],  
  props: {
    minNumber: {
      type: Number,
      default: 1,
    },
    maxNumber: {
      type: Number,
      required: true
    },
    showZero: {
      type: Boolean,
      default: false,
    },
    zeroString: {
      type: String,
      default: '없음',
    },
    /**
     * 접두어
     */
    prefixString: {
      type: String,
      default: '',
    },
    /**
     * 접미어
     */
    suffixString: {
      type: String,
      default: '',
    }
  },
  computed: {
    items: function() {
      let items = [];
      for (let i = this.minNumber; i <= this.maxNumber; i++) {
        items.push(i);
      }
      return items;
    }
  },  
};
</script>
